import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import MDInput from "components/MDInput";
import { useCallback, useEffect, useState } from "react";
import CommonSelect from "components/CommonSelect/select";
import { companiesSync } from "rest/sync/requestsSync";
import { getCatalogSectorsSync } from "rest/sync/requestsSync";
import { getCatalogSubSectorsSync } from "rest/sync/requestsSync";
import { getQuarters } from "rest/requests";
import { reportCompareCompanySales } from "rest/requests";
import { formatData } from "./formatDataForDataTable";
import DataTable from "components/CustomDataTable/CompareCompaniesDataTable";
import { getExcelData } from "./getExcelData";
import TitleCustom from "components/CustomTitle";

function build_export_file_name(companiesCatalog, selectedCompanyId1, selectedCompanyId2) {
  try {
    const selectedCompany1Name = selectedCompanyId1
      ? companiesCatalog.filter((e) => e.id === selectedCompanyId1)[0].name
      : "";
    const selectedCompany2Name = selectedCompanyId2
      ? companiesCatalog.filter((e) => e.id === selectedCompanyId2)[0].name
      : "";

    return "Comparacion_Empresas_" + selectedCompany1Name + "_vs_" + selectedCompany2Name + ".xlsx";
  } catch {
    return "Comparar_Empresas_.xlsx";
  }
}

function ComapaniesContrast() {
  const companiesCatalog = companiesSync();
  const catalogSector = getCatalogSectorsSync();
  const catalogSubSector = getCatalogSubSectorsSync();

  const [selectedCompany1, setSelectedCompany1] = useState(null);
  const [selectedCompany2, setSelectedCompany2] = useState(null);
  const [selectedSector, setSelectedSector] = useState(null);
  const [selectedSubSector, setSelectedSubSector] = useState(null);

  const [companyData1, setCompanyData1] = useState([]);
  const [companyData2, setCompanyData2] = useState([]);

  // ------ Year select ----------
  const [year, setYear] = useState(new Date().getFullYear());
  const handleYear = (event) => {
    const {
      target: { value },
    } = event;
    setYear(value);
  };
  // ------ Year select END----------
  const getData = useCallback(async () => {
    if (String(year).length == 4) {
      if (selectedCompany1) {
        const _company1 = await reportCompareCompanySales(
          selectedCompany1,
          year,
          selectedSector,
          selectedSubSector
        );
        const _quarters = await getQuarters(year);
        const quartersId = _quarters.length > 0 ? _quarters : [182, 64, 46, 47];
        console.log("Data company 1: ", _company1);
        console.log("quartersId", quartersId);
        setCompanyData1(_company1);
      }
    }
  }, [year, selectedCompany1, selectedSector, selectedSubSector]);

  useEffect(() => {
    getData();
  }, [year, selectedCompany1, selectedSector, selectedSubSector]);

  const getData2 = useCallback(async () => {
    if (String(year).length == 4) {
      if (selectedCompany2) {
        const _company2 = await reportCompareCompanySales(
          selectedCompany2,
          year,
          selectedSector,
          selectedSubSector
        );
        const _quarters = await getQuarters(year);
        const quartersId = _quarters.length > 0 ? _quarters : [182, 64, 46, 47];
        console.log("quartersId", quartersId);
        setCompanyData2(_company2);
      }
    }
  }, [year, selectedCompany2, selectedSector, selectedSubSector]);

  useEffect(() => {
    getData2();
  }, [year, selectedCompany2, selectedSector, selectedSubSector]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox>
        <TitleCustom
          title={"Comparar Empresas"}
          excelData={getExcelData(
            companiesCatalog,
            selectedCompany1,
            companyData1,
            selectedCompany2,
            companyData2
          )}
          excelName={build_export_file_name(companiesCatalog, selectedCompany1, selectedCompany2)}
          showChart={false}
          setShowChart={null}
        ></TitleCustom>
      </MDBox>

      <MDBox bgColor="white" variant="gradient" borderRadius="sm" shadow="sm" opacity={1} p={1}>
        <Grid container spacing={2}>
          <Grid item>
            <MDInput type="number" label="Year" value={year} onChange={handleYear} />
          </Grid>
          <Grid item>
            <CommonSelect
              label="Sector"
              data={catalogSector}
              onChange={(selectedValue) => setSelectedSector(selectedValue)}
            ></CommonSelect>
          </Grid>
          <Grid item>
            <CommonSelect
              label="Sub Sector"
              data={catalogSubSector}
              onChange={(selectedValue) => setSelectedSubSector(selectedValue)}
            ></CommonSelect>
          </Grid>
        </Grid>
      </MDBox>

      <Grid container>
        <Grid item xs={12} md={6} padding={1}>
          <MDBox
            bgColor="white"
            variant="gradient"
            borderRadius="sm"
            shadow="sm"
            opacity={1}
            p={1}
            style={{ marginBottom: "3px" }}
          >
            <CommonSelect
              label="Empresa 1"
              data={companiesCatalog}
              onChange={(selectedValue) => setSelectedCompany1(selectedValue)}
            ></CommonSelect>
          </MDBox>
          <DataTable table={formatData(companyData1)} canSearch={true} />
        </Grid>
        <Grid item xs={12} md={6} padding={1}>
          <MDBox
            bgColor="white"
            variant="gradient"
            borderRadius="sm"
            shadow="sm"
            opacity={1}
            p={1}
            style={{ marginBottom: "3px" }}
          >
            <CommonSelect
              label="Empresa 2"
              data={companiesCatalog}
              onChange={(selectedValue) => setSelectedCompany2(selectedValue)}
            ></CommonSelect>
          </MDBox>
          <DataTable table={formatData(companyData2)} canSearch={true} />
        </Grid>
      </Grid>

      <Footer />
    </DashboardLayout>
  );
}

export default ComapaniesContrast;
